import { termsRepository } from '~/api/repository/terms';

// ============================================================================
// Terms Query Keys
// ============================================================================

export const TERMS_QUERY_KEY = {
  all: ['terms'] as const,

  /** 약관 조회 */
  list: (bundleId: string) => ({
    queryKey: [...TERMS_QUERY_KEY.all, 'list', bundleId] as const,
    queryFn: () => termsRepository.getTerms(bundleId),
  }),

  /** 주소 등록 약관 조회 */
  address: () => ({
    queryKey: [...TERMS_QUERY_KEY.all, 'address'] as const,
    queryFn: () => termsRepository.getAddressTerms(),
  }),
};
